import React, { Component } from 'react';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import apiFetch from './services/ApiClient'; // adjust path if needed

function getQueryParam(search, name) {
    const p = new URLSearchParams(search);
    return p.get(name);
}

export class ResetPassword extends Component {
    static displayName = ResetPassword.name;

    constructor(props) {
        super(props);

        const userId = getQueryParam(props.location?.search ?? window.location.search, 'uid');
        const token = getQueryParam(props.location?.search ?? window.location.search, 'token');
        const mode = getQueryParam(props.location?.search ?? window.location.search, 'mode');

        this.state = {
            userId: userId ?? '',
            token: token ?? '',
            mode: mode ?? '',
            newPassword: '',
            confirmPassword: '',
            submitting: false,
            done: false,
            error: null
        };
    }

    submit = async () => {
        if (!this.state.userId || !this.state.token) {
            this.setState({ error: 'Missing reset token or user id.' });
            return;
        }
        if (!this.state.newPassword || this.state.newPassword !== this.state.confirmPassword) {
            this.setState({ error: 'Passwords do not match.' });
            return;
        }

        this.setState({ submitting: true, error: null });

        try {
            const r = await apiFetch('/api/Account/ResetPassword', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId: this.state.userId,
                    token: this.state.token,
                    newPassword: this.state.newPassword
                })
            });

            if (r.status !== 200) {
                this.setState({ submitting: false, error: 'Reset failed.' });
                return;
            }

            this.setState(
                { submitting: false, done: true, token: '', userId: '' }, // Clears token and userid from state after successful reset
                () => {
                    window.history.replaceState({}, document.title, '/resetpassword'); // Clears query params from URL after successful reset
                }
            );
        } catch (e) {
            this.setState({ submitting: false, error: String(e) });
        }
    }

    render() {
        const logo = {
            width: '250px',
            padding: '1.5em',
            margin: '20px auto',
            display: 'block'
        };

        return (
            <Container>
                <Row style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'></Col>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'>
                        <div>
                            <img src="logo.jpg" alt="logo" style={logo} />
                        </div>

                        {this.state.done ? (
                            <>
                                <p>
                                    {this.state.mode === 'invite'
                                        ? 'Password set successfully. Your account is now active.'
                                        : 'Password reset successful.'}
                                </p>
                                <Button color="primary" onClick={() => window.location.href = '/login'}>
                                    Back to Login
                                </Button>
                            </>
                        ) : (
                            <>
                                <p>
                                    {this.state.mode === 'invite'
                                        ? 'Welcome! Please set your password to activate your account.'
                                        : 'Please enter a new password below.'}
                                </p>

                                <Input
                                    type='password'
                                    value={this.state.newPassword}
                                    onChange={(e) => this.setState({ newPassword: e.target.value })}
                                    name='newPassword'
                                    id='newPassword'
                                    placeholder='New Password'
                                />
                                <br />
                                <Input
                                    type='password'
                                    value={this.state.confirmPassword}
                                    onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                    name='confirmPassword'
                                    id='confirmPassword'
                                    placeholder='Confirm Password'
                                />
                                <br />
                                <Button
                                    color='primary'
                                    disabled={this.state.submitting}
                                    onClick={this.submit}
                                >
                                    {this.state.submitting ? 'Submitting...' : 'Submit'}
                                </Button>

                                {this.state.error && (
                                    <div style={{ marginTop: 12, color: 'crimson', textAlign: 'left' }}>
                                        {this.state.error}
                                    </div>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}
